













































import { Vue, Component, Prop } from 'vue-property-decorator';
import { EButtonType } from '@getaccept/lib-ui';
import type { ISigningStep } from '@signing-page/signing/types/signing-step';
import Pin from '@signing-page/common/components/Pin.vue';

@Component({
  components: {
    Pin,
  },
  data: () => ({
    EButtonType,
  }),
})
export default class VerifySms extends Vue {
  @Prop() error: boolean;
  @Prop() step: ISigningStep;
  @Prop() loading: boolean;

  pin = '';
  hasSentPin = false;
  pinLength = 6;

  get description(): string {
    return `${this.$t('sms-auth-description')} ${this.lastFourDigits}.`;
  }

  get infoText(): string {
    return `${this.$t('sms-info-text')} ${this.lastFourDigits}.`;
  }

  get lastFourDigits(): string {
    return this.step.data.mobile;
  }

  get disableValidate(): boolean {
    return this.pin.length !== this.pinLength;
  }

  get codeSent(): boolean {
    return this.hasSentPin;
  }

  close(): void {
    this.$emit('close');
  }

  handlePin(pin: string) {
    this.pin = pin;
  }

  sendPin() {
    this.hasSentPin = true;
    this.$emit('sendPin');
  }

  handleAnswer() {
    this.$emit('verify', this.pin);
  }

  bindEnter({ key }: KeyboardEvent) {
    if (key === 'Enter') {
      this.handleAnswer();
    }
  }

  mounted() {
    document.addEventListener('keydown', this.bindEnter);
  }

  beforeDestroy() {
    document.removeEventListener('keydown', this.bindEnter);
  }
}
